import axios from 'axios'
import { config } from '../util/config'

let API = function() {
  let userData = JSON.parse(localStorage.getItem("userData"))  
  let baseAPI 

  if(userData != null) {
    let accessToken = userData.access_token

    baseAPI = axios.create({
        baseURL: config.backendURL + '/api',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${accessToken}`,
        },
    })
  }
  else {
    baseAPI = axios.create({
      baseURL: config.backendURL + '/api',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    })
  }

  return baseAPI
}

export default API; 